import React, { useEffect, useState } from "react";
import "./AdminPage.css"; 
import "./AppointmentSelector.css";
import background from "./images/sketch1736085284692.jpg";
import Swal from "sweetalert2";

const monthNames = [
  "január", "február", "március", "április", "május", "június",
  "július", "augusztus", "szeptember", "október", "november", "december",
];

function AppointmentSelector() {
  useEffect(() => {
    document.title = "Időpontfoglalás";
  }, []);

  const [timeSlots, setTimeSlots] = useState({});
  const [selectedSlot, setSelectedSlot] = useState(null);
  const [selectedMonth, setSelectedMonth] = useState(new Date().getMonth() + 1);
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    fetch("/api/time-slots/?t=" + new Date().getTime())
      .then((response) => response.json())
      .then((data) => {
        const slots = data.time_slots ? data.time_slots : (Array.isArray(data) ? data : []);
        const grouped = {};
        slots.forEach((s) => {
          if (!s.is_booked) {
            const parts = s.date.split("-");
            const m = parseInt(parts[1], 10);
            const d = String(parseInt(parts[2], 10));
            if (!grouped[m]) grouped[m] = {};
            if (!grouped[m][d]) {
              // JAVÍTÁS: a teljes valódi dátumot (évvel együtt) tároljuk,
              // nem találjuk ki utólag egy fix "selectedYear"-ből.
              grouped[m][d] = { date: s.date, times: [] };
            }
            const tStr = s.time.substring(0, 5);
            if (!grouped[m][d].times.includes(tStr)) grouped[m][d].times.push(tStr);
          }
        });
        setTimeSlots(grouped);
      })
      .catch((err) => console.error("Hiba:", err));
  }, []);

  const handleSlotSelect = (time, fullDate) => {
    setSelectedSlot({ date: fullDate, time: time });
  };

  const handleSubmit = () => {
    if (!selectedSlot) {
      Swal.fire("Hiba", "Válassz ki egy időpontot!", "error");
      return;
    }

    setIsSubmitting(true);
    const userData = JSON.parse(localStorage.getItem("userData") || "{}");
    userData.date = selectedSlot.date;
    userData.time = selectedSlot.time;

    fetch("/api/create-appointment/", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(userData),
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.status === "success" || data.message) {
          Swal.fire("Siker!", "Időpont sikeresen mentve!", "success").then(() => {
            localStorage.clear();
            window.location.href = "/success.html";
          });
        } else {
          setIsSubmitting(false);
          Swal.fire("Hiba", data.error || "Hiba történt.", "error");
        }
      })
      .catch(() => {
        setIsSubmitting(false);
        Swal.fire("Hiba", "Hálózati hiba történt.", "error");
      });
  };

  const monthData = timeSlots[selectedMonth];
  // JAVÍTÁS: a fejlécben mutatott évet is a tényleges adatból olvassuk ki,
  // az adott hónap első napjának valódi dátumából - nem találgatjuk.
  const displayYear = monthData
    ? Object.values(monthData)[0]?.date?.split("-")[0]
    : new Date().getFullYear();

  return (
    <div className="timeslots-page" style={{ backgroundImage: `url(${background})` }}>
      <div className="timeslots-container">
        <h1 className="timeslots-title">Elérhető Időpontok {displayYear}</h1>
        
        <select 
          className="timeslots-select" 
          value={selectedMonth} 
          onChange={(e) => setSelectedMonth(parseInt(e.target.value, 10))}
        >
          {monthNames.map((n, i) => <option key={i} value={i + 1}>{n}</option>)}
        </select>

        <div className="timeslot-list" style={{ maxHeight: "350px", overflowY: "auto" }}>
          {monthData && Object.keys(monthData).length > 0 ? (
            Object.keys(monthData).sort((a, b) => a - b).map((day) => {
              const dayData = monthData[day];
              return (
                <div key={day} style={{ marginBottom: "20px" }}>
                  <h3 className="timeslot-day">{day}. nap</h3>
                  <div style={{ display: "flex", flexWrap: "wrap", justifyContent: "center", gap: "10px" }}>
                    {dayData.times.sort().map((t, i) => {
                      const isSel = selectedSlot && selectedSlot.date === dayData.date && selectedSlot.time === t;
                      return (
                        <span 
                          key={i} 
                          className={`timeslot-time ${isSel ? "selected" : ""}`}
                          onClick={() => handleSlotSelect(t, dayData.date)}
                          style={{ 
                            cursor: "pointer",
                            backgroundColor: isSel ? "#ffffff" : "rgba(255,255,255,0.2)",
                            color: isSel ? "#978274" : "#ffffff",
                            border: "1px solid white"
                          }}
                        >
                          {t}
                        </span>
                      );
                    })}
                  </div>
                </div>
              );
            })
          ) : (
            <p className="timeslot-day">Nincs elérhető időpont.</p>
          )}
        </div>

        <button 
          className="submit-btn" 
          onClick={handleSubmit} 
          disabled={isSubmitting || !selectedSlot}
          style={{
            marginTop: "25px",
            padding: "12px 25px",
            backgroundColor: selectedSlot ? "#ffffff" : "#ccc",
            color: "#978274",
            border: "none",
            borderRadius: "5px",
            fontWeight: "bold",
            cursor: selectedSlot ? "pointer" : "not-allowed",
            width: "80%"
          }}
        >
          {isSubmitting ? "Feldolgozás..." : "Foglalás megerősítése"}
        </button>
      </div>
      
      {/* Alsó távolság az admin stílushoz */}
      <div style={{ minHeight: "50px" }}></div>
    </div>
  );
}

export default AppointmentSelector;
